<template>
    <section id="packages-container">
        <nav class="hidden-mobile">
            <a href="#" v-show="!showAllFilters" class="show-all-filters-link" @click.prevent="toggleFilters()"><i
                    class="fa fa-caret-down"></i></a>

            <div v-if="canSeeOtherKanbans" class="mb-2">
                <ui-select-searchable
                        class="w-full sm:w-60"
                        label=""
                        v-model="kanban_user"
                        :options="employee_options"
                ></ui-select-searchable>
            </div>

            <div class="mb-4">
                <div class="flex flex-row gap-4">
                    <filter-bar :filters="filterList"
                                :hide-all="true"
                                :initial-filter="filter"
                                :do-not-listen-to-filter-change-events="true"
                                @change="mainFilterChanged"
                                :high-contrast="true"></filter-bar>

                    <a class="text-gray-400 hover:text-underline text-sm mt-2" href="#"
                       @click.prevent="toggleMoreFilters()">{{
                            showMoreFilters ? 'Hide...' : 'More...'
                        }}</a>
                    <package-search-button class="ml-auto"></package-search-button>
                </div>
                <div v-if="showMoreFilters" class="flex flex-row mt-2">
                    <filter-bar :filters="secondaryFilterList"
                                :hide-all="true"
                                :can-be-deactivated="true"
                                :initial-filter="null"
                                :multiple="true"
                                :do-not-listen-to-filter-change-events="true"
                                @change="secondaryFiltersChanged"
                                :high-contrast="true"
                                size="small"></filter-bar>
                </div>
            </div>

        </nav>
        <main id="packages-kanban-area" v-show="!showAllFilters">
            <div v-for="statusId in status_ids">
                <div>
                    <heading size="small" class="border-b-2 border-blue-50">
                      {{ getPackageStatusNameById(statusId) }}
                      <small class="float-right text-gray-300">{{ queriedPackages[statusId].length }}</small>
                    </heading>
                    <div v-if="is_loading[statusId]" class="loading-spinner">
                        <div class="double-bounce1"></div>
                        <div class="double-bounce2"></div>
                    </div>
                    <ul v-else>
                        <li v-for="packageItem in queriedPackages[statusId]">
                            <a class="text-brand" :href="packageItem._links.frontend.view" >
                                <strong>{{ packageItem.project }}</strong><br/>
                                {{ packageItem.name }},
                                <span>Ref: {{ packageItem.reference }},</span>
                                <span>{{ packageItem.address }}</span>
                            </a>

                            <a :href="packageItem.client._links.frontend.view" v-if="packageItem.client" class="client-link">
                              {{ packageItem.client.name }}
                            </a>
                          <div class="meta-icons">
                            <i class="fas fa-sync" v-if="packageItem.meta.repeat" title="Repeat Business"></i>
                            <i class="fas fa-lock" v-if="packageItem.meta.secured" title="Secured"></i>
                            <i class="fa fa-pause" v-if="packageItem.meta.hold" title="On Hold"></i>
                            <i class="fa fa-ban" v-if="packageItem.meta.unable_to_quote" title="Unable To Quote"></i>
                            <i class="fa fa-exclamation-circle" v-if="packageItem.meta.snagging" title="Snagging"></i>
                            <i class="fa fa-times" v-if="packageItem.meta.dead" title="Dead"></i>
                            <i class="fa fa-archive" v-if="packageItem.meta.archive" title="Archive"></i>
                            <i class="fa fa-link" v-if="packageItem.meta.linked" title="Linked To Other Packages"></i>
                            <i class="fa fa-hourglass-end" v-if="packageItem.meta.inactive" title="Inactive"></i>
                          </div>

                          <div v-if="packageItem.status.id >= 400" class="relative pt-2">

                            <div class="overflow-hidden h-1 mb-2 text-xs flex rounded bg-gray-200">
                              <div :style="`width:${packageItem.progress}%`"
                                   class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center"
                                   :class="{
                                    'bg-red-500': packageItem.progress < 20,
                                    'bg-yellow-500':packageItem.progress >= 20 && packageItem.progress <= 50,
                                    'bg-brand':packageItem.progress > 50 && packageItem.progress <= 75,
                                    'bg-green-500':packageItem.progress > 75
                                   }"
                              ></div>
                            </div>

                            <div class="text-right">
                                <span class="text-xs font-semibold inline-block text-brand-dark">
                                  {{packageItem.progress }}%
                                </span>
                            </div>
                          </div>

                        </li>
                    </ul>
                </div>
            </div>
        </main>
    </section>
</template>

<script>

    //    <a :href="package._links.frontend.view">
    //        <strong>{{ package.project }}</strong><br/>
    //    {{ package.name }},
    //    <span>{{ package.address }}</span>

    var stringSearcher = function (stringToSearchWithin, stringToFind) {

        if (_.isInteger(stringToSearchWithin)) {
            stringToSearchWithin = stringToSearchWithin.toString();
        }

        stringToSearchWithin = stringToSearchWithin.toLowerCase();

        if (_.isInteger(stringToFind)) {
            stringToFind = stringToFind.toString();
        }

        if (_.isString(stringToFind)) {
            return _.includes(stringToSearchWithin, stringToFind)
        }

        return false;
    };

    var packageMatchesString = function (packer, stringToFind) {
        if (stringSearcher(packer.id, stringToFind))
            return true;

        if (stringSearcher(packer.name, stringToFind))
            return true;

        if (stringSearcher(packer.project, stringToFind))
            return true;

        if (packer.client && packer.client.name && stringSearcher(packer.client.name, stringToFind))
            return true;

        if (stringSearcher(packer.reference, stringToFind))
            return true;

        if (stringSearcher(packer.address, stringToFind))
            return true;

        if (stringSearcher(packer.postcode, stringToFind))
            return true;

        return false;
    };

    export default {
        data() {
            return {
                query: '',
                packages: {
                    100: [],
                    200: [],
                    300: [],
                    400: [],
                    500: [],
                    600: [],
                    700: []
                },
                employees: [],
                kanban_user: { label: "Everyone's Packages", value: null },
                filter: 'flag__active',
                secondaryFilters: [],
                secondaryFilterList: {
                    due__rams: 'RAMS Due',
                    due__progress: 'Progress Report Due',
                    open__rfm: 'Open RFMs',
                    open__rfi: 'Open RFIs',
                    open__eot: 'Open EOTs',
                    open__ncr: 'Open NCRs',
                    open__defect: 'Open Defects',
                    open__callback: 'Open Call Backs',
                    is__secured: 'Secured',
                    is__repeat: 'Repeat',
                    is__inactive: 'Inactive',
                },
                filterList: {
                    flag__active: 'Active',
                    flag__deleted: 'Deleted',
                    flag__unable_to_quote: 'Unable To Quote',
                    flag__dead: 'Dead',
                    flag__archived: 'Archived',
                    flag__hold: 'On Hold',
                    flag__radar: 'Radar',
                    flag__unseen: 'Unseen',
                    flag__hot: 'Hot',
                    flag__imminent: 'Imminent',
                    flag__all: 'All',
                },
                showAllFilters: false,
                showMoreFilters: false,
                is_loading: {
                    100: true,
                    200: true,
                    300: true,
                    400: true,
                    500: true,
                    600: true,
                    700: true
                },
                counts: {
                    100: 0,
                    200: 0,
                    300: 0,
                    400: 0,
                    500: 0,
                    600: 0,
                    700: 0
                },
                status_map: {
                    100: 'New Enquiry',
                    200: 'Quoting',
                    300: 'Quoted',
                    400: 'Secured',
                    500: 'Booked',
                    600: 'In Progress',
                    700: 'Complete',
                }
            }
        },
        props: {
            canSeeOtherKanbans: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            employee_options(){
              let options = [
                  { label: "Everyone's Packages", value: null },
                  { label: "My Packages", value: "my" },
                  { label: "Without Staff", value: "none" },
              ];

              _.forEach(this.employees, function(employee){
                 options.push({
                     label: employee.name,
                     value: employee.id
                 })
              });

              return options;
            },
            status_ids: function () {
                return this.getStatusIds();
            },
            loading: function () {
                var loading = false;
                var that = this;
                _.forEach(that.getStatusIds(), function (statusId) {
                    if (that.is_loading[statusId]) {
                        loading = true;
                    }
                });

                return loading;
            },
            queriedPackages: function () {
                var that = this;
                var query = this.query.trim().toLowerCase();
                var queriedPackages = $.extend({}, this.packages);

                if (query && query != '') {
                    _.forEach(queriedPackages, function (packageList, key) {
                        queriedPackages[key] = _.filter(packageList, function (packer) {
                            return packageMatchesString(packer, query);
                        });
                    });
                }

                return queriedPackages;
            }
        },
        watch: {
            filter: function (value) {
                this.showAllFilters = false;
                this.getAllPackages();
            },
            secondaryFilters: function (value) {
                this.showAllFilters = false;
                this.getAllPackages();
            },
            kanban_user(value){
                this.getAllPackages();
            }
        },
        methods: {
            toggleMoreFilters() {
                this.showMoreFilters = !this.showMoreFilters;
            },
            activateFilter: function (filterName) {
                eventBus.$emit('package-kanban-filter-changed', filterName);
            },
            toggleFilters: function () {
                this.showAllFilters = !this.showAllFilters;
            },
            getAllPackages: function () {
                var that = this;

                _.forEach(that.getStatusIds(), function (statusId) {
                    that.packages[statusId] = [];
                    that.getPackages(statusId);
                });
            },
            getPackageStatusNameById: function (status) {
                return this.status_map[status];
            },
            getEmployees: function () {
                var that = this;
                var url = route('api.v1.employees.list');
                axios.get(url)
                    .then(response => {
                        that.employees = response.data.data
                    });
            },
            getPackages: function (statusId) {
                var that = this;
                var url = appUrls.packages.index;
                var parameters = {
                    status_id: statusId,
                    kanban: true,
                    filters: [this.filter],
                    all: true
                };

                if (_.isObject(this.kanban_user) && this.kanban_user.value) {
                    parameters.person = this.kanban_user.value
                }

                if (_.isArray(this.secondaryFilters)) {
                    _.forEach(this.secondaryFilters,function(filterName){
                      parameters.filters.push(filterName)
                    })
                }

                this.is_loading[statusId] = true;

                axios.get(url, {params: parameters})
                    .then(response => {
                        that.is_loading[statusId] = false;
                        that.counts[statusId] = response.data.data.length;
                        that.packages[statusId] = response.data.data;
                    });
            },
            getStatusIds: function () {
                return Object.keys(this.status_map);
            },
            searchPackages: function (query) {
                this.query = query;
            },
            mainFilterChanged(filters){
                if (_.isEmpty(filters)) {
                    this.filter = 'all';
                } else {
                    this.filter = filters[0];
                }
                this.showAllFilters = false;
            },
            secondaryFiltersChanged(filters){
                this.secondaryFilters = filters
            },
        },
        mounted() {
            var that = this;
            this.getAllPackages();
            this.getEmployees();

            eventBus.$on('package-search-query-changed', _.debounce(function (query) {
                that.searchPackages(query);
            }, 250));

        }
    }
</script>

<style lang="scss" scoped>
    $kanban-grid: (
            columns: 7,
            gutter: 20px,
            media: 'screen'
    );

    #packages-container {
        @include grid-container();
        @include grid-collapse();
        nav {
            display: block;
            padding: 0 20px;
            @include clearfix();
            @include mobile() {
                padding: 0;
                margin-left: 5%;
                margin-right: 5%;
            }

            .packages-kanban-filters {
                text-align: left;
                float: left;
            }

            @media (max-width: 900px) {
                .packages-kanban-filters {
                    float: none;
                    display: block;
                    text-align: center;
                }
            }

        }
        #packages-kanban-area {
            display: flex;
        }
        @media (max-width: 1419px) {
            #packages-kanban-area {
                overflow-x: scroll;
                > div {
                    width: 30%;
                    min-width: 30%;
                }
            }
        }
        @include mobile(){
            #packages-kanban-area {
                overflow-x: scroll;
                padding-bottom: 1em;
                scroll-snap-type: mandatory;
                scroll-snap-destination: 0% 100%;
                scroll-snap-points-x: repeat(100%);
                white-space: nowrap;
                > div {
                    scroll-snap-align: start;
                    display: inline-block;
                    width: 100%;
                    min-width: 100%;
                    margin: 0;
                    > div {
                        margin: 0 5%;
                    }
                }
                &::-webkit-scrollbar-track {
                    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
                    background-color: #F5F5F5;
                }

                &::-webkit-scrollbar {
                    height: 10px;
                    background-color: #F5F5F5;
                }

                &::-webkit-scrollbar-thumb {
                    background: $brand -webkit-gradient(linear, 0 0, 0 100%,
                            color-stop(.5, rgba(255, 255, 255, .2)),
                            color-stop(.5, transparent), to(transparent));
                }
            }
        }

        #packages-kanban-area > div {
            // Force each div to use a custom grid of 7 columns
            // Not concerned with media queries here as we're going to wrap this all up in a scrolly-div
            > div {
                box-shadow: 3px 4px 4px 0px rgba(0, 0, 0, 0.04);
                background-color: #FFF;
                border-radius: $standardBorderRadius;
                padding: 0.7em;
            }

            @include desktop() {
                @include grid-media($kanban-grid) {
                    @include grid-column(1);
                }
            }
            ul {
                overflow-x: hidden;
                overflow-y: scroll;
                -webkit-overflow-scrolling: touch;
                height: calc(100vh - 250px);
                max-height: calc(100vh - 250px);
                position: relative;
                @include mobile() {
                    height: calc(100vh - 250px);
                    max-height: calc(100vh - 250px);
                }
            }
            ul, li {
                font-size: 13px;
                line-height: 18px;
                margin-bottom: 0.6em;
                padding-bottom: 0.4em;
                border-bottom: 1px dashed rgb(222, 222, 222);
                font-weight: 500;
                span {
                    font-size: 0.9em;
                    display: block;
                    color: #bcc5c9;
                    margin-top: 5px;
                }
                strong {
                    font-weight: 800;
                }
                @include clearfix();
                &:last-of-type {
                    border-bottom: none;
                    padding-bottom: 0;
                }
                a {
                    text-decoration: none;
                }
                a.client-link {
                    display: block;
                    font-size: 0.9em;
                    color: #bcc5c9;
                    margin-top: 5px;
                    &:hover {
                        color: $brand;
                    }
                }
                .meta-icons {
                    text-align: right;
                    font-size: 14px;
                    color: #8ab7ce;
                    i {
                        margin-left: 8px;
                    }
                }
            }

        }

        .show-all-filters-link {
            display: none;
        }

        @include mobile() {
            .show-all-filters-link {
                display: inline-block;
                height: 28px;
                float: right;
                border-radius: 0 $standardBorderRadius $standardBorderRadius 0;
            }
            #packages-kanban-area {
                @include clearfix();
                width: 100%;
                position: relative;
            }
            .packages-kanban-filters {
                a {
                    display: none;
                }
                a.show-em, a.active {
                    display: block;
                }
            }
            footer {
                display: block;
                margin: 1em auto;
                text-align: center;
                a {
                    color: #999;
                    transition: color 0.1s ease-in-out;
                    margin: 0 0.25em;
                    &.active {
                        color: $brand;
                    }
                }
            }
        }

        @include desktop() {
            footer {
                display: none;
            }
        }

    }
</style>
